import React from "react";
import { VideoModal, type VideoModalProps } from "ui/video";
import { useSwiperSlide } from "swiper/react";

/**
 * Returns a video modal that is used in the home page `CaseStudySlider`.
 * The background video is only playing when it's the active slide.
 */
export function SliderVideo(props: VideoModalProps) {
  const swiperSlide = useSwiperSlide();
  const isActive = swiperSlide?.isActive;

  return <VideoModal autoplayBgVideo={false} isBgVideoPlaying={isActive} {...props} />;
}
